import { useEffect, useRef, useState } from 'react'

import TutorOnDemandProductCard from './components/ProductCard.component'
import useTutorOnDemandProductCards from './TutorOnDemandProductCards.hook'

export default function TutorOnDemandProductCards({
  className = '',
  colorScheme,
  hideVideoChatWithTutor = false,
  hideChatWithTutor = false,
}: {
  className?: string
  colorScheme?: 'sky' | 'white'
  hideVideoChatWithTutor?: boolean
  hideChatWithTutor?: boolean
}): React.ReactElement {
  const colorSchemeIsWhite = colorScheme === 'white'
  const config = { hideChatWithTutor, hideVideoChatWithTutor, colorSchemeIsWhite }
  const products = useTutorOnDemandProductCards(config)
  const [shouldLoadVideos, setShouldLoadVideos] = useState(false)
  const sectionRef = useRef(null)

  useEffect(() => {
    const options = {
      root: null,
      threshold: 0,
      rootMargin: '300px 300px',
    }

    const observer = new IntersectionObserver((entries) => {
      const componentIsVisible = entries.some((entry) => {
        return entry.isIntersecting
      })

      if (componentIsVisible) {
        setShouldLoadVideos(true)
        observer.disconnect()
      }
    }, options)

    const target = sectionRef.current

    if (target) observer.observe(target)

    return () => observer.disconnect()
  }, [])

  return (
    <section className={`${className}`} ref={sectionRef}>
      {products.map((product) => (
        <TutorOnDemandProductCard
          key={product.title}
          shouldLoadVideos={shouldLoadVideos}
          {...product}
          colorScheme={colorScheme}
        />
      ))}
    </section>
  )
}
